import hoverintent from 'hoverintent';

const listItemClass = 'site-navigation__list-item--has-children';
const hoverClass = 'site-navigation__list-item--hover';
const toggleClass = 'site-navigation__list-item--is-open';
const toggleClassChannelSelector = 'site-navigation-channel-selector--is-open';

class Navigation {
	constructor() {
		this.nav = document.getElementById('siteNavigation');
		this.channelSelector = document.getElementById(
			'siteNavigationChannelSelector',
		);

		if (this.nav) {
			this.attachHoverEvents();
			this.attachMobileToggleEvent();
		}

		if (this.channelSelector) {
			this.attachChannelSelectorEvent();
		}
	}

	attachHoverEvents() {
		const hoverElements = this.nav.querySelectorAll('[data-children="true"]');

		for (let i = 0; i < hoverElements.length; i += 1) {
			this.attachHoverEvent(hoverElements[i]);
		}
	}

	attachHoverEvent(el) {
		hoverintent(
			el,
			() => this.toggleHoverClass(el),
			() => this.toggleHoverClass(el),
		).options({
			timeout: 200,
		});
	}

	toggleHoverClass(el) {
		const { device } = window.od;

		if (device() === 'lg') {
			el.classList.toggle(hoverClass);

			if (el.classList.contains(hoverClass)) {
				this.setArrowPosition(el);
			}
		}
	}

	setArrowPosition(el) {
		const arrow = el.querySelector('.arrow');
		let pos = el.offsetLeft + el.offsetWidth / 2;
		pos -= arrow.offsetWidth / 2;
		arrow.style.left = `${pos}px`;
	}

	attachMobileToggleEvent() {
		this.nav.addEventListener(
			'click',
			e => {
				this.toggleListItemClass(e);
			},
			false,
		);
	}

	attachChannelSelectorEvent() {
		this.channelSelectorLink = document.getElementById(
			'siteNavigationChannelSelectorButton',
		);
		this.channelSelectorLink.addEventListener(
			'click',
			() => {
				this.toggleChannelSelector();
			},
			false,
		);
	}

	toggleChannelSelector() {
		const ariaExpanded =
			this.channelSelectorLink.getAttribute('aria-expanded') === 'true';
		this.channelSelectorLink.setAttribute('aria-expanded', !ariaExpanded);
		this.channelSelector.classList.toggle(toggleClassChannelSelector);
	}

	toggleListItemClass(e) {
		const { device } = window.od;

		if (device() === 'xs') {
			let el = e.target;

			if (this.isTargetRegion(el)) {
				e.preventDefault();
				el = this.getListItem(el);
				el.classList.toggle(toggleClass);

				if (el.classList.contains(toggleClass)) {
					this.removeSiblingListItemClass(this.getSiblings(el));
				}
			}
		}
	}

	getListItem(el) {
		return this.isListItemLink(el) ? el.parentNode : el;
	}

	isTargetRegion(el) {
		return this.isListItem(el) || this.isListItemLink(el);
	}

	isListItem(el) {
		return el && el.tagName === 'LI' && el.classList.contains(listItemClass);
	}

	isListItemLink(el) {
		return (
			el &&
			el.tagName === 'A' &&
			el.parentNode.classList.contains(listItemClass)
		);
	}

	getSiblings(el) {
		const elements = this.nav.getElementsByClassName(el.className);
		const siblings = [];

		for (let i = 0; i < elements.length; i += 1) {
			const sibling = elements[i];
			if (sibling !== el) {
				siblings.push(sibling);
			}
		}

		return siblings;
	}

	removeSiblingListItemClass(elements) {
		elements.forEach(el => el.classList.remove(toggleClass));
	}
}

export default Navigation;
